const downloadFile = (data) => {
    const link = document.createElement('a');
    link.href = data.fileUrl;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export { downloadFile };
